/* =============================================
   CTRLZED — Shopify Theme JS
   ctrlzed.js
   ============================================= */

document.addEventListener('DOMContentLoaded', function () {

  /* ----- Mobile Menu ----- */
  var toggle = document.querySelector('.mobile-menu-toggle');
  var mobileNav = document.querySelector('.mobile-nav');
  if (toggle && mobileNav) {
    toggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.contains('is-open');
      mobileNav.classList.toggle('is-open', !isOpen);
      toggle.setAttribute('aria-expanded', String(!isOpen));
    });
    mobileNav.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () {
        mobileNav.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  /* ----- Product Gallery Thumbnails ----- */
  var thumbs = document.querySelectorAll('.product-thumb');
  var mainImage = document.querySelector('.product-gallery-main img');
  if (thumbs.length && mainImage) {
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var newSrc = thumb.dataset.image;
        if (newSrc) {
          mainImage.src = newSrc;
          thumbs.forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        }
      });
    });
  }

  /* ----- Quantity Input ----- */
  var qtyContainers = document.querySelectorAll('.quantity-input');
  qtyContainers.forEach(function (container) {
    var input = container.querySelector('input[type="number"]');
    var minus = container.querySelector('.quantity-minus');
    var plus  = container.querySelector('.quantity-plus');
    if (!input) return;
    if (minus) {
      minus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        if (val > 1) { input.value = val - 1; input.dispatchEvent(new Event('change')); }
      });
    }
    if (plus) {
      plus.addEventListener('click', function () {
        var val = parseInt(input.value, 10) || 1;
        input.value = val + 1;
        input.dispatchEvent(new Event('change'));
      });
    }
  });

  /* ----- Variant Selector ----- */
  var variantSelect = document.getElementById('variant-select');
  var priceEl       = document.querySelector('.product-current-price');
  var origPriceEl   = document.querySelector('.product-original-price');
  var addToCartBtn  = document.querySelector('.product-add-to-cart');

  if (variantSelect) {
    // Sync radio option selects → hidden variant select
    var optionRadios = document.querySelectorAll('.option-values input[type="radio"]');
    optionRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        syncVariant();
      });
    });

    function syncVariant() {
      // Build selected options array from checked radios
      var selected = [];
      var optionGroups = document.querySelectorAll('.product-option');
      optionGroups.forEach(function (group) {
        var checked = group.querySelector('input[type="radio"]:checked');
        if (checked) selected.push(checked.value);
      });
      // Find matching variant option in select
      var options = variantSelect.options;
      for (var i = 0; i < options.length; i++) {
        var title = options[i].text;
        if (selected.every(function (s) { return title.indexOf(s) > -1; })) {
          variantSelect.value = options[i].value;
          variantSelect.dispatchEvent(new Event('change'));
          break;
        }
      }
    }

    variantSelect.addEventListener('change', function () {
      var selected = variantSelect.options[variantSelect.selectedIndex];
      var price    = selected.dataset.price;
      var origPrice = selected.dataset.comparePrice;
      var available = selected.dataset.available !== 'false';

      if (priceEl && price) {
        priceEl.textContent = price;
      }
      if (origPriceEl) {
        origPriceEl.style.display = (origPrice && origPrice !== '0') ? '' : 'none';
        if (origPrice) origPriceEl.textContent = origPrice;
      }
      if (addToCartBtn) {
        addToCartBtn.disabled = !available;
        addToCartBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
      }
    });
  }

  /* ----- Add to Cart (AJAX) ----- */
  var productForm = document.getElementById('product-form');
  var noticeEl    = document.querySelector('.added-to-cart-notice');

  function updateCartBadge(count) {
    // Always query live — badge may not exist on page load if cart was empty
    var cartCountEl = document.querySelector('.cart-count');
    if (cartCountEl) {
      cartCountEl.textContent = count;
      cartCountEl.style.display = count > 0 ? '' : 'none';
    } else if (count > 0) {
      var link = document.querySelector('.cart-link');
      if (link) {
        var badge = document.createElement('span');
        badge.className = 'cart-count';
        badge.textContent = count;
        link.appendChild(badge);
      }
    }
  }

  /* DISABLED: duplicate handler. main-product.liquid already handles the product-form submit
     (adds to cart and opens the drawer). Running both added every item twice. */
  if (productForm && false) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = productForm.querySelector('.product-add-to-cart');
      var formData = new FormData(productForm);
      var data = {};
      formData.forEach(function (value, key) { data[key] = value; });

      // Disable button while adding
      if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(data.id, 10), quantity: parseInt(data.quantity, 10) || 1 })
      })
      .then(function (res) {
        if (!res.ok) {
          // Try to get error message from Shopify response
          return res.json().then(function (errData) {
            throw new Error(errData.description || errData.message || 'Could not add to cart');
          });
        }
        return res.json();
      })
      .then(function () {
        return fetch('/cart.js');
      })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartBadge(cart.item_count);

        // Show confirmation notice
        if (noticeEl) {
          noticeEl.textContent = '✓ Added to cart';
          noticeEl.style.color = '';
          noticeEl.classList.add('is-visible');
          setTimeout(function () { noticeEl.classList.remove('is-visible'); }, 3000);
        }

        // Re-enable button
        if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }

        // Scroll to top on mobile so user sees the notice
        if (window.innerWidth < 768) {
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
      })
      .catch(function (err) {
        console.error('Cart add error:', err);
        // Show visible error so user knows what happened
        if (noticeEl) {
          noticeEl.textContent = err.message || 'Something went wrong — please try again.';
          noticeEl.style.color = '#c0392b';
          noticeEl.classList.add('is-visible');
          setTimeout(function () { noticeEl.classList.remove('is-visible'); }, 5000);
        }
        // Re-enable button
        if (btn) { btn.disabled = false; btn.textContent = 'Add to Cart'; }
      });
    });
  }

  /* ----- Cart: Remove Item ----- */
  document.querySelectorAll('.cart-item-remove').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var key = btn.dataset.key;
      if (!key) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 })
      }).then(function () {
        window.location.reload();
      });
    });
  });

  /* ----- Cart: Update Quantity ----- */
  document.querySelectorAll('.cart-qty-input').forEach(function (input) {
    input.addEventListener('change', function () {
      var key = input.dataset.key;
      var qty = parseInt(input.value, 10);
      if (!key) return;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(function () {
        window.location.reload();
      });
    });
  });

  /* ----- Collection Sort ----- */
  var sortSelect = document.querySelector('.collection-sort select');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sortSelect.value);
      window.location.href = url.toString();
    });
  }

});
